export const availableIcons = [
    'accounts',
    'address-book',
    'advisor',
    'advisor-blg',
    'alarm-clock',
    'alarm_ringing',
    'algemene-voorwaarden',
    'arrow-down',
    'arrow-left',
    'arrow-right',
    'arrow-up',
    'asterisk',
    'atm-receipt',
    'balance-chart',
    'balloon',
    'bell',
    'block-expand-mo',
    'book',
    'browsercode',
    'bullet',
    'bullhorn',
    'calculator',
    'calculator-under-roof-reb',
    'calendar',
    'calendar-check',
    'card-detailed-asn',
    'card-detailed-reb',
    'card-limit',
    'card-limit-asn',
    'card-locked',
    'card-unlocked',
    'card-world',
    'chair',
    'chat',
    'checkbox-checked',
    'checkbox-unchecked',
    'checkmark',
    'chevron-down',
    'chevron-down-animated',
    'chevron-explanation-down',
    'chevron-explanation-up',
    'chevron-left',
    'chevron-right',
    'chevron-up',
    'clear',
    'clock',
    'close',
    'cog',
    'compass',
    'constant-payments',
    'contact',
    'conversational-chat',
    'copy',
    'credit-card',
    'declining-payments',
    'delete',
    'digicode',
    'digicode-settings',
    'digipas',
    'digipas-back',
    'digipas-limit',
    'digipas-unblock',
    'download',
    'drag',
    'drag-handle',
    'edit',
    'ellipsis-vertical',
    'emoji-angry',
    'emoji-excited',
    'emoji-happy',
    'emoji-neutral',
    'emoji-sad',
    'envelope',
    'envelope-open',
    'eppo',
    'exchange',
    'exclamation',
    'exclamation-triangle',
    'external-link',
    'eye',
    'eye-slash',
    'facebook',
    'family',
    'file',
    'file-audio',
    'file-default',
    'file-excel',
    'file-image',
    'file-pdf',
    'file-powerpoint',
    'file-signature',
    'file-video',
    'file-word',
    'file-zip',
    'folder',
    'folder-open',
    'globe',
    'hamburger-menu',
    'help',
    'help-required-reb',
    'helpdesk',
    'house',
    'house-percentage',
    'increasing-payments',
    'interest-pig',
    'inzicht',
    'inzicht-alimentatie',
    'inzicht-bankkosten',
    'inzicht-belastingen-toeslagen',
    'inzicht-beleggen',
    'inzicht-boodschappen',
    'inzicht-cadeaus',
    'inzicht-contanten',
    'inzicht-dier-tuin',
    'inzicht-eigen-rekening',
    'inzicht-eten-drinken',
    'inzicht-familie',
    'inzicht-gas-water-licht',
    'inzicht-goede-doelen',
    'inzicht-hobby-sport-vrije-tijd',
    'inzicht-huishouden-electronica',
    'inzicht-huur-hypotheek',
    'inzicht-internet-tv-bellen',
    'inzicht-kinderen',
    'inzicht-kleding',
    'inzicht-klussen-onderhoud',
    'inzicht-lening',
    'inzicht-onderwijs',
    'inzicht-overig',
    'inzicht-pensioen',
    'inzicht-salaris',
    'inzicht-sparen',
    'inzicht-stufi',
    'inzicht-uitkering',
    'inzicht-vakantie',
    'inzicht-vervoer',
    'inzicht-verzekeringen',
    'inzicht-verzorging-gezondheid',
    'inzicht-zak-en-kleedgeld',
    'laptop',
    'legitimatie-scan',
    'lightbulb',
    'limits',
    'linkedin',
    'location-arrow',
    'lock-alt',
    'lock-open-alt',
    'logo-aegon',
    'logo-allianz',
    'logo-app-store-dark',
    'logo-app-store-light',
    'logo-apple-pay',
    'logo-asn',
    'logo-asn-black',
    'logo-asn-dark',
    'logo-asn-white',
    'logo-asr',
    'logo-attens',
    'logo-blg',
    'logo-centraal-beheer',
    'logo-contactloos-betalen',
    'logo-delta-lloyd',
    'logo-dvb',
    'logo-emandates',
    'logo-google-pay',
    'logo-google-play',
    'logo-ideal',
    'logo-ideal-qr',
    'logo-idin',
    'logo-idin-qr',
    'logo-lloyds',
    'logo-nibc',
    'logo-nn',
    'logo-onderlinge',
    'logo-orange-credit',
    'logo-reaal',
    'logo-reb',
    'logo-sns',
    'logo-sns-white',
    'logo-syntrus-achmea',
    'logo-thuiswinkel-waarborg',
    'logo-unicolor-asn',
    'logo-wero',
    'logo-woonfonds',
    'logout',
    'magnifier',
    'magnifier-file',
    'map-marker-alt',
    'meatballs-menu',
    'min',
    'minimize',
    'minus-circle',
    'mirror',
    'mobile',
    'money-in-hand',
    'moneybag',
    'mood-icon-dislike-dark',
    'mood-icon-dislike-light',
    'mood-icon-hate-dark',
    'mood-icon-hate-light',
    'mood-icon-like-dark',
    'mood-icon-like-light',
    'mood-icon-love-dark',
    'mood-icon-love-light',
    'mood-icon-neutral-dark',
    'mood-icon-neutral-light',
    'more',
    'nfc',
    'overstapservice',
    'paperclip',
    'payment-request',
    'pending',
    'percent',
    'phone',
    'plant-in-hand',
    'play-circle',
    'plus',
    'plus-circle',
    'printer',
    'privacy',
    'qrcode',
    'question-circle',
    'questionmark',
    'raquo-right-blg',
    'recurring-payment',
    'redo',
    'reject',
    'scale',
    'send',
    'shop',
    'sliders-h',
    'sort',
    'sort-down',
    'sort-up',
    'spaarpot-auto',
    'spaarpot-bad',
    'spaarpot-bbq',
    'spaarpot-bestek',
    'spaarpot-blender',
    'spaarpot-cadeau',
    'spaarpot-camera',
    'spaarpot-caravan',
    'spaarpot-dier',
    'spaarpot-diploma',
    'spaarpot-dokter',
    'spaarpot-feest',
    'spaarpot-fiets',
    'spaarpot-games',
    'spaarpot-gereedschap',
    'spaarpot-gitaar',
    'spaarpot-grafiek',
    'spaarpot-hart',
    'spaarpot-hobby',
    'spaarpot-horloge',
    'spaarpot-huisje',
    'spaarpot-juwelen',
    'spaarpot-kerstboom',
    'spaarpot-kind',
    'spaarpot-kiwi',
    'spaarpot-kleding',
    'spaarpot-koelkast',
    'spaarpot-koffer',
    'spaarpot-laptop',
    'spaarpot-meubels',
    'spaarpot-openhaard',
    'spaarpot-paard',
    'spaarpot-portrait',
    'spaarpot-rijlessen',
    'spaarpot-schaar',
    'spaarpot-schep',
    'spaarpot-scooter',
    'spaarpot-ship',
    'spaarpot-sinterklaas',
    'spaarpot-solar-panel',
    'spaarpot-sparen',
    'spaarpot-speaker',
    'spaarpot-sport',
    'spaarpot-tandarts',
    'spaarpot-tas',
    'spaarpot-telefoon',
    'spaarpot-tiny-house',
    'spaarpot-trouwen',
    'spaarpot-tv',
    'spaarpot-vakantie',
    'spaarpot-veiligheid',
    'spaarpot-verbouwen',
    'spaarpot-verjaardag',
    'spaarpot-wasmachine',
    'spaarpot-winkel',
    'spaarpot-winkelwagen',
    'spaarpot-winter',
    'spaarpot-zon',
    'spaarpot-zonnebril',
    'star',
    'star-solid',
    'sticky-note',
    'tasks',
    'thumb-slider',
    'times-circle',
    'transfer',
    'twitter',
    'umbrella',
    'undo',
    'upload',
    'user',
    'vergelijkbaretransacties',
    'wallet',
    'whatsapp'
] as const;

export type AvailableIcons =
    | 'accounts'
    | 'address-book'
    | 'advisor'
    | 'advisor-blg'
    | 'alarm-clock'
    | 'alarm_ringing'
    | 'algemene-voorwaarden'
    | 'arrow-down'
    | 'arrow-left'
    | 'arrow-right'
    | 'arrow-up'
    | 'asterisk'
    | 'atm-receipt'
    | 'balance-chart'
    | 'balloon'
    | 'bell'
    | 'block-expand-mo'
    | 'book'
    | 'browsercode'
    | 'bullet'
    | 'bullhorn'
    | 'calculator'
    | 'calculator-under-roof-reb'
    | 'calendar'
    | 'calendar-check'
    | 'card-detailed-asn'
    | 'card-detailed-reb'
    | 'card-limit'
    | 'card-limit-asn'
    | 'card-locked'
    | 'card-unlocked'
    | 'card-world'
    | 'chair'
    | 'chat'
    | 'checkbox-checked'
    | 'checkbox-unchecked'
    | 'checkmark'
    | 'chevron-down'
    | 'chevron-down-animated'
    | 'chevron-explanation-down'
    | 'chevron-explanation-up'
    | 'chevron-left'
    | 'chevron-right'
    | 'chevron-up'
    | 'clear'
    | 'clock'
    | 'close'
    | 'cog'
    | 'compass'
    | 'constant-payments'
    | 'contact'
    | 'conversational-chat'
    | 'copy'
    | 'credit-card'
    | 'declining-payments'
    | 'delete'
    | 'digicode'
    | 'digicode-settings'
    | 'digipas'
    | 'digipas-back'
    | 'digipas-limit'
    | 'digipas-unblock'
    | 'download'
    | 'drag'
    | 'drag-handle'
    | 'edit'
    | 'ellipsis-vertical'
    | 'emoji-angry'
    | 'emoji-excited'
    | 'emoji-happy'
    | 'emoji-neutral'
    | 'emoji-sad'
    | 'envelope'
    | 'envelope-open'
    | 'eppo'
    | 'exchange'
    | 'exclamation'
    | 'exclamation-triangle'
    | 'external-link'
    | 'eye'
    | 'eye-slash'
    | 'facebook'
    | 'family'
    | 'file'
    | 'file-audio'
    | 'file-default'
    | 'file-excel'
    | 'file-image'
    | 'file-pdf'
    | 'file-powerpoint'
    | 'file-signature'
    | 'file-video'
    | 'file-word'
    | 'file-zip'
    | 'folder'
    | 'folder-open'
    | 'globe'
    | 'hamburger-menu'
    | 'help'
    | 'help-required-reb'
    | 'helpdesk'
    | 'house'
    | 'house-percentage'
    | 'increasing-payments'
    | 'interest-pig'
    | 'inzicht'
    | 'inzicht-alimentatie'
    | 'inzicht-bankkosten'
    | 'inzicht-belastingen-toeslagen'
    | 'inzicht-beleggen'
    | 'inzicht-boodschappen'
    | 'inzicht-cadeaus'
    | 'inzicht-contanten'
    | 'inzicht-dier-tuin'
    | 'inzicht-eigen-rekening'
    | 'inzicht-eten-drinken'
    | 'inzicht-familie'
    | 'inzicht-gas-water-licht'
    | 'inzicht-goede-doelen'
    | 'inzicht-hobby-sport-vrije-tijd'
    | 'inzicht-huishouden-electronica'
    | 'inzicht-huur-hypotheek'
    | 'inzicht-internet-tv-bellen'
    | 'inzicht-kinderen'
    | 'inzicht-kleding'
    | 'inzicht-klussen-onderhoud'
    | 'inzicht-lening'
    | 'inzicht-onderwijs'
    | 'inzicht-overig'
    | 'inzicht-pensioen'
    | 'inzicht-salaris'
    | 'inzicht-sparen'
    | 'inzicht-stufi'
    | 'inzicht-uitkering'
    | 'inzicht-vakantie'
    | 'inzicht-vervoer'
    | 'inzicht-verzekeringen'
    | 'inzicht-verzorging-gezondheid'
    | 'inzicht-zak-en-kleedgeld'
    | 'laptop'
    | 'legitimatie-scan'
    | 'lightbulb'
    | 'limits'
    | 'linkedin'
    | 'location-arrow'
    | 'lock-alt'
    | 'lock-open-alt'
    | 'logo-aegon'
    | 'logo-allianz'
    | 'logo-app-store-dark'
    | 'logo-app-store-light'
    | 'logo-apple-pay'
    | 'logo-asn'
    | 'logo-asn-black'
    | 'logo-asn-dark'
    | 'logo-asn-white'
    | 'logo-asr'
    | 'logo-attens'
    | 'logo-blg'
    | 'logo-centraal-beheer'
    | 'logo-contactloos-betalen'
    | 'logo-delta-lloyd'
    | 'logo-dvb'
    | 'logo-emandates'
    | 'logo-google-pay'
    | 'logo-google-play'
    | 'logo-ideal'
    | 'logo-ideal-qr'
    | 'logo-idin'
    | 'logo-idin-qr'
    | 'logo-lloyds'
    | 'logo-nibc'
    | 'logo-nn'
    | 'logo-onderlinge'
    | 'logo-orange-credit'
    | 'logo-reaal'
    | 'logo-reb'
    | 'logo-sns'
    | 'logo-sns-white'
    | 'logo-syntrus-achmea'
    | 'logo-thuiswinkel-waarborg'
    | 'logo-unicolor-asn'
    | 'logo-wero'
    | 'logo-woonfonds'
    | 'logout'
    | 'magnifier'
    | 'magnifier-file'
    | 'map-marker-alt'
    | 'meatballs-menu'
    | 'min'
    | 'minimize'
    | 'minus-circle'
    | 'mirror'
    | 'mobile'
    | 'money-in-hand'
    | 'moneybag'
    | 'mood-icon-dislike-dark'
    | 'mood-icon-dislike-light'
    | 'mood-icon-hate-dark'
    | 'mood-icon-hate-light'
    | 'mood-icon-like-dark'
    | 'mood-icon-like-light'
    | 'mood-icon-love-dark'
    | 'mood-icon-love-light'
    | 'mood-icon-neutral-dark'
    | 'mood-icon-neutral-light'
    | 'more'
    | 'nfc'
    | 'overstapservice'
    | 'paperclip'
    | 'payment-request'
    | 'pending'
    | 'percent'
    | 'phone'
    | 'plant-in-hand'
    | 'play-circle'
    | 'plus'
    | 'plus-circle'
    | 'printer'
    | 'privacy'
    | 'qrcode'
    | 'question-circle'
    | 'questionmark'
    | 'raquo-right-blg'
    | 'recurring-payment'
    | 'redo'
    | 'reject'
    | 'scale'
    | 'send'
    | 'shop'
    | 'sliders-h'
    | 'sort'
    | 'sort-down'
    | 'sort-up'
    | 'spaarpot-auto'
    | 'spaarpot-bad'
    | 'spaarpot-bbq'
    | 'spaarpot-bestek'
    | 'spaarpot-blender'
    | 'spaarpot-cadeau'
    | 'spaarpot-camera'
    | 'spaarpot-caravan'
    | 'spaarpot-dier'
    | 'spaarpot-diploma'
    | 'spaarpot-dokter'
    | 'spaarpot-feest'
    | 'spaarpot-fiets'
    | 'spaarpot-games'
    | 'spaarpot-gereedschap'
    | 'spaarpot-gitaar'
    | 'spaarpot-grafiek'
    | 'spaarpot-hart'
    | 'spaarpot-hobby'
    | 'spaarpot-horloge'
    | 'spaarpot-huisje'
    | 'spaarpot-juwelen'
    | 'spaarpot-kerstboom'
    | 'spaarpot-kind'
    | 'spaarpot-kiwi'
    | 'spaarpot-kleding'
    | 'spaarpot-koelkast'
    | 'spaarpot-koffer'
    | 'spaarpot-laptop'
    | 'spaarpot-meubels'
    | 'spaarpot-openhaard'
    | 'spaarpot-paard'
    | 'spaarpot-portrait'
    | 'spaarpot-rijlessen'
    | 'spaarpot-schaar'
    | 'spaarpot-schep'
    | 'spaarpot-scooter'
    | 'spaarpot-ship'
    | 'spaarpot-sinterklaas'
    | 'spaarpot-solar-panel'
    | 'spaarpot-sparen'
    | 'spaarpot-speaker'
    | 'spaarpot-sport'
    | 'spaarpot-tandarts'
    | 'spaarpot-tas'
    | 'spaarpot-telefoon'
    | 'spaarpot-tiny-house'
    | 'spaarpot-trouwen'
    | 'spaarpot-tv'
    | 'spaarpot-vakantie'
    | 'spaarpot-veiligheid'
    | 'spaarpot-verbouwen'
    | 'spaarpot-verjaardag'
    | 'spaarpot-wasmachine'
    | 'spaarpot-winkel'
    | 'spaarpot-winkelwagen'
    | 'spaarpot-winter'
    | 'spaarpot-zon'
    | 'spaarpot-zonnebril'
    | 'star'
    | 'star-solid'
    | 'sticky-note'
    | 'tasks'
    | 'thumb-slider'
    | 'times-circle'
    | 'transfer'
    | 'twitter'
    | 'umbrella'
    | 'undo'
    | 'upload'
    | 'user'
    | 'vergelijkbaretransacties'
    | 'wallet'
    | 'whatsapp';

export const spaarpotIconNames = [
    'spaarpot-auto',
    'spaarpot-bad',
    'spaarpot-bbq',
    'spaarpot-bestek',
    'spaarpot-blender',
    'spaarpot-cadeau',
    'spaarpot-camera',
    'spaarpot-caravan',
    'spaarpot-dier',
    'spaarpot-diploma',
    'spaarpot-dokter',
    'spaarpot-feest',
    'spaarpot-fiets',
    'spaarpot-games',
    'spaarpot-gereedschap',
    'spaarpot-gitaar',
    'spaarpot-grafiek',
    'spaarpot-hart',
    'spaarpot-hobby',
    'spaarpot-horloge',
    'spaarpot-huisje',
    'spaarpot-juwelen',
    'spaarpot-kerstboom',
    'spaarpot-kind',
    'spaarpot-kiwi',
    'spaarpot-kleding',
    'spaarpot-koelkast',
    'spaarpot-koffer',
    'spaarpot-laptop',
    'spaarpot-meubels',
    'spaarpot-openhaard',
    'spaarpot-paard',
    'spaarpot-portrait',
    'spaarpot-rijlessen',
    'spaarpot-schaar',
    'spaarpot-schep',
    'spaarpot-scooter',
    'spaarpot-ship',
    'spaarpot-sinterklaas',
    'spaarpot-solar-panel',
    'spaarpot-sparen',
    'spaarpot-speaker',
    'spaarpot-sport',
    'spaarpot-tandarts',
    'spaarpot-tas',
    'spaarpot-telefoon',
    'spaarpot-tiny-house',
    'spaarpot-trouwen',
    'spaarpot-tv',
    'spaarpot-vakantie',
    'spaarpot-veiligheid',
    'spaarpot-verbouwen',
    'spaarpot-verjaardag',
    'spaarpot-wasmachine',
    'spaarpot-winkel',
    'spaarpot-winkelwagen',
    'spaarpot-winter',
    'spaarpot-zon',
    'spaarpot-zonnebril'
] as const;

export type SpaarpotIconNames =
    | 'spaarpot-auto'
    | 'spaarpot-bad'
    | 'spaarpot-bbq'
    | 'spaarpot-bestek'
    | 'spaarpot-blender'
    | 'spaarpot-cadeau'
    | 'spaarpot-camera'
    | 'spaarpot-caravan'
    | 'spaarpot-dier'
    | 'spaarpot-diploma'
    | 'spaarpot-dokter'
    | 'spaarpot-feest'
    | 'spaarpot-fiets'
    | 'spaarpot-games'
    | 'spaarpot-gereedschap'
    | 'spaarpot-gitaar'
    | 'spaarpot-grafiek'
    | 'spaarpot-hart'
    | 'spaarpot-hobby'
    | 'spaarpot-horloge'
    | 'spaarpot-huisje'
    | 'spaarpot-juwelen'
    | 'spaarpot-kerstboom'
    | 'spaarpot-kind'
    | 'spaarpot-kiwi'
    | 'spaarpot-kleding'
    | 'spaarpot-koelkast'
    | 'spaarpot-koffer'
    | 'spaarpot-laptop'
    | 'spaarpot-meubels'
    | 'spaarpot-openhaard'
    | 'spaarpot-paard'
    | 'spaarpot-portrait'
    | 'spaarpot-rijlessen'
    | 'spaarpot-schaar'
    | 'spaarpot-schep'
    | 'spaarpot-scooter'
    | 'spaarpot-ship'
    | 'spaarpot-sinterklaas'
    | 'spaarpot-solar-panel'
    | 'spaarpot-sparen'
    | 'spaarpot-speaker'
    | 'spaarpot-sport'
    | 'spaarpot-tandarts'
    | 'spaarpot-tas'
    | 'spaarpot-telefoon'
    | 'spaarpot-tiny-house'
    | 'spaarpot-trouwen'
    | 'spaarpot-tv'
    | 'spaarpot-vakantie'
    | 'spaarpot-veiligheid'
    | 'spaarpot-verbouwen'
    | 'spaarpot-verjaardag'
    | 'spaarpot-wasmachine'
    | 'spaarpot-winkel'
    | 'spaarpot-winkelwagen'
    | 'spaarpot-winter'
    | 'spaarpot-zon'
    | 'spaarpot-zonnebril';
